export const getOriginalPricing = ({
    numberOfRepayments,
    totalCreditAmount
}: {
    numberOfRepayments: number;
    totalCreditAmount: number;
}) => {
    //This function gets the original price that an RBL would have gotten if
    //they were to receive our max interest rate of 2.5%.
    const monthlyRate = 0.025; //max interest rate for DE currently
    const dailyRate = monthlyRate / 30; // Convert monthly rate to daily rate
    const rateFactor = (1 + dailyRate) / dailyRate; // Factor that adjusts based on rate
    const repaymentFactor =
        1 - 1 / Math.pow(1 + dailyRate, numberOfRepayments + 1); // Factor based on number of repayments
    const denominator = rateFactor * repaymentFactor - 1; // Complete denominator calculation
    const fee = numberOfRepayments / denominator - 1; // Final fee calculation

    const originalFeeAmount = fee * totalCreditAmount + 50; //there is an additional fixed fee of 50 euros for RBL;;

    return originalFeeAmount;
};
